import { Map } from 'maplibre-gl';
import { getAppleMapsAccessToken } from '@/utils/map';
import { LAYER_ID as ROADS_LAYER_ID } from '@/components/ui/map/styles/RoadLayers';

const BANANA_URL =
  'https://cdn.apple-mapkit.com/ma/bootstrap?apiVersion=2&mkjsVersion=5.45.0-63&poi=1';
const SOURCE_ID = 'banana-wms';
export const LAYER_ID = 'banana-raster';

const config: { appleToken: string | null } = {
  appleToken: null,
};

const isValid = (expiration: string) => {
  const exp = isNaN(Number(expiration)) ? 0 : Number(expiration);
  return new Date().getTime() < exp;
};

const requestToken = async () => {
  try {
    const res = await fetch(BANANA_URL, {
      headers: {
        authorization: `Bearer ${getAppleMapsAccessToken()}`,
      },
    });

    const json = await res.json();

    if ('error' in json) {
      console.error('Failed to get token', json.error);
      return;
    }

    config.appleToken = json.accessKey;

    const halfHour = 60 * 30 * 1000;
    const expiry = new Date().getTime() + halfHour;

    localStorage.setItem('bananaToken', `${json.accessKey}:${expiry}`);
  } catch (error) {
    console.error('Failed to get token', error);
  }
};

export async function init() {
  const bananaToken = localStorage.getItem('bananaToken');
  if (bananaToken) {
    const [token, expiration] = bananaToken.split(':');
    if (isValid(expiration)) {
      config.appleToken = token;
    } else {
      await requestToken();
    }
  } else {
    await requestToken();
  }
}

export function addSource(map: Map) {
  if (!map.getSource(SOURCE_ID) && config.appleToken) {
    const accessKey = encodeURIComponent(config.appleToken);
    map.addSource(SOURCE_ID, {
      maxzoom: 19,
      tiles: [
        `https://sat-cdn1.apple-mapkit.com/tile?style=7&size=2&scale=1&z={z}&x={x}&y={y}&v=9871&accessKey=${accessKey}`,
        `https://sat-cdn2.apple-mapkit.com/tile?style=7&size=2&scale=1&z={z}&x={x}&y={y}&v=9871&accessKey=${accessKey}`,
        `https://sat-cdn3.apple-mapkit.com/tile?style=7&size=2&scale=1&z={z}&x={x}&y={y}&v=9871&accessKey=${accessKey}`,
        `https://sat-cdn4.apple-mapkit.com/tile?style=7&size=2&scale=1&z={z}&x={x}&y={y}&v=9871&accessKey=${accessKey}`,
      ],
      tileSize: 512,
      type: 'raster',
    });
  }
}

export function addLayer(map: Map) {
  if (map.getSource(SOURCE_ID) && !map.getLayer(LAYER_ID)) {
    map.addLayer(
      {
        id: LAYER_ID,
        source: SOURCE_ID,
        type: 'raster',
      },
      ROADS_LAYER_ID,
    );
  }
}

export function removeLayer(map: Map) {
  if (map.getLayer(LAYER_ID)) {
    map.removeLayer(LAYER_ID);
  }
}
